import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";

export const useDraftOperations = (
  content: string,
  draftId?: string,
  onSaveDraft?: () => void,
  onClear?: () => void,
  contentType: "draft" | "scheduled" = "draft"
) => {
  const handleSaveDraft = async (content: string, images: string[] = [], video: string | null = null) => {
    try {
      if (draftId && contentType === "draft") {
        // Update existing draft
        const { error } = await supabase
          .from('drafts')
          .update({ 
            content,
            images,
            video,
            updated_at: new Date().toISOString()
          })
          .eq('id', draftId);

        if (error) throw error;
      } else {
        // Create new draft only if there's no draftId
        const { error } = await supabase
          .from('drafts')
          .insert({
            content,
            images,
            video,
            user_id: (await supabase.auth.getUser()).data.user?.id || '',
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          });

        if (error) throw error;
      }

      toast.success("Draft saved successfully!");
      onSaveDraft?.();
    } catch (error) {
      console.error('Error saving draft:', error);
      toast.error("Failed to save draft");
    }
  };

  const handlePublish = async (content: string) => {
    try {
      return {
        success: true,
        message: "Published successfully"
      };
    } catch (error) {
      console.error('Error publishing:', error);
      return {
        success: false,
        message: error.message
      };
    }
  };

  return {
    handleSaveDraft,
    handlePublish,
  };
};